// @flow
import { AppBar } from "@mui/material";
import React from 'react';
import { Title } from "../../../pages/main/common";

type Props = {

};

const NoDrawerLayout = (props: Props) => {
	return (
		<AppBar
			elevation={0}
			position="fixed"
			open={true}
			sx={{backgroundColor: props.color}}
		>
			<Title/>
		</AppBar>
	)
};

export default NoDrawerLayout